<template>
	<div class="SingleDayGraph">
		<div
			v-if="isGraphDataAvailable"
			ref="singleDay"
			style="width: 100%; height: 400px; overflow: hidden;"
		></div>
		<div v-else>
			<h3 style="text-align: center; padding-top: 50px;">No Data Found</h3>
		</div>
	</div>
</template>
<script>
var echarts = require("echarts");
import { GraphData } from "../../../../mixins/baseReportGraphData";
import { EventBus } from "../../../eventBus";
import moment from "moment";

export default {
	name: "SingleDayGraph",
	mixins: [GraphData],
	props: {
		graphName: {
			type: String,
			default: () => ""
		}
	},
	data() {
		return {
			daySchdulerGraphInstance: "",
			// colors: ["#C7FFFE", "#FFCEE3", "#FFB1D2"],
			colors: ["#6cd2eb", "#FFB1D2", "#409eff"],
			isGraphDataAvailable: true
		};
	},
	mounted() {
		EventBus.$on("salesLineGraph", data => {
			console.log("graph", data);
			this.initBaseGraph();

			// timeout is temporary remove it after testing
			setTimeout(() => {
				this.map_graph_data(data);
			}, 2000);
		});
	},
	beforeDestroy() {
		EventBus.$off();
	},
	methods: {
		map_graph_data(graph_data) {
			this.graphXaxis[0].data = [];
			this.graphSeries = [];
			this.getNameOfGraph = this.graphName;
			this.graphColors = this.colors;
			// this.graphLegend.top = 10;
			let sales = {
				name: "Current Sales",
				type: "line",
				data: []
			};

			let last_period = {
				name: "Last Period",
				type: "line",
				data: []
			};

			let forecast = {
				name: "Forecast",
				type: "line",
				data: []
				// yAxisIndex: 1
			};
			let target = {
				name: "Target",
				type: "line",
				data: []
				// yAxisIndex: 1
			};
			// this.graphXaxis[0].data = [];
			this.graphYaxis = [
				{
					type: "value",
					name: "",
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					}
				}
			];
			this.graphXaxis[0].axisLine = {
				show: false
			};
			this.graphXaxis[0].axisTick = {
				show: false
			};
			if (graph_data.length) {
				for (var i = 0; i < graph_data.length; i++) {

					if (this.graphName == "Hourly View") {
						this.graphXaxis[0].data.push(
							new Date(graph_data[i].name).toLocaleString("en-US", {
								hour: "numeric",
								hour12: true
							})
						);
					} else if (this.graphName == "Daily View") {
						this.graphXaxis[0].data.push(
							moment(graph_data[i].name).format("YYYY-MM-DD")
						);
					} else {
						this.graphXaxis[0].data.push(graph_data[i].name);
					}
					forecast.data.push(graph_data[i].forecast);
					sales.data.push(graph_data[i].sales);
					last_period.data.push(graph_data[i].last);
					target.data.push(graph_data[i].target);
				}
			} else {
				this.isGraphDataAvailable = false;
			}
			this.graphSeries.push(sales);
			this.graphSeries.push(target);
			this.graphSeries.push(last_period);
			this.graphSeries.push(forecast);

			this.reRenderGraph();
			console.log("graphData", this.graphData);
		},

		clearGraph: function() {
			this.daySchdulerGraphInstance.clear();
		},

		reRenderGraph: function() {
			this.clearGraph();
			this.daySchdulerGraphInstance.setOption(this.graphData);
			this.daySchdulerGraphInstance.hideLoading();
		},

		initBaseGraph() {
			let baseGraphContainer = this.$refs["singleDay"];
			this.daySchdulerGraphInstance = echarts.init(
				baseGraphContainer,
				null,
				this.initOptions
			);
			this.daySchdulerGraphInstance.showLoading();
		}
	}
};
</script>
